import * as React from 'react';
export const playSvg = React.forwardRef(function playSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.177 1.913a.288.288 0 0 0-.427.252v11.671c0 .22.247.355.426.253l9.935-5.88c.179-.105.179-.321 0-.426-3.323-1.935-6.622-3.91-9.932-5.869h-.002ZM4.063.404A2.012 2.012 0 0 0 3.055.126C1.989.122 1 .966 1 2.165v11.671c0 1.188.985 2.043 2.05 2.04a2 2 0 0 0 1.008-.276l9.937-5.881A1.982 1.982 0 0 0 15 7.996c0-.667-.336-1.333-1.008-1.725-3.322-1.935-6.62-3.91-9.929-5.867Z',
    }),
  );
});
playSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var play = {
  category: 'icon',
  colorable: true,
  name: 'play',
  svg: playSvg,
};
